
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanProjectUnit/LeanProjectUnit.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanProjectUnit.html');
        
        var script = require('./LeanProjectUnit.ts').default;
        module.exports = require('./LeanProjectUnit.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    